export function HtmlEntitiesDecode(encodedString) {
  const entities = {
    amp: '&',
    apos: "'",
    '#x27': "'",
    '#x2F': '/',
    '#39': "'",
    '#34': '"',
    '#47': '/',
    lt: '<',
    gt: '>',
    nbsp: ' ',
    quot: '"',
  };
  return encodedString.replace(/&([^;]+);/gm, (match, entity) => {
    return entities[entity] || match;
  });
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/HtmlEntities/HtmlEntities.js